const url='https://s3.eu-central-1.amazonaws.com/naura-builds/';
const listParams='?list-type=2';
const getTaggingParams='?tagging';

const request=(urlParams,resolve,reject)=>{
    const xhttp=new XMLHttpRequest();
    xhttp.open("GET", url+urlParams, true);
    xhttp.setRequestHeader("Content-type", "application/json; charset=utf8");
    xhttp.setRequestHeader( 'Access-Control-Allow-Origin', '*');
    xhttp.setRequestHeader( 'Access-Control-Allow-Methods','GET, POST, PATCH, PUT, DELETE, OPTIONS');
    xhttp.setRequestHeader( 'Access-Control-Allow-Headers', 'Origin, Content-Type, X-Auth-Token');
    xhttp.onreadystatechange = () =>{
        if (xhttp.readyState === xhttp.DONE) {
            if (xhttp.status === 200) {
                resolve(xhttp.responseText)
            }else{
                reject(xhttp.status,xhttp.responseText);
            }
        }
    };
    xhttp.send();
};

export const list=(resolve,reject)=>{
    request(listParams,resolve,reject);
};

export const getTags=(key,resolve,reject)=>{
    request(key.key+getTaggingParams,resolve,reject);
};

//(res)=>resolve(key,res)